import '.c8{position:relative;}.ssr-plugin'
import '.x{width:100%;}.ssr-plugin'
import '.h6{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.c1{align-items:flex-start;}.ssr-plugin'
import '.z{padding:2rem;}.ssr-plugin'
import '.cq{background:var(--palette-white);}.ssr-plugin'
import '.ae{overflow:hidden;}.ssr-plugin'
import '.b9{position:absolute;}.ssr-plugin'
import '.jz{top:50%;}.ssr-plugin'
import '.k0{right:1rem;}.ssr-plugin'
import '.k1{transform:translateY(-50%);}.ssr-plugin'
import '.k2{width:120px;}.ssr-plugin'
import '.k3{height:120px;}.ssr-plugin'
import '.k4{z-index:0;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.ge{z-index:1;}.ssr-plugin'
import '.aq{gap:0.5rem;}.ssr-plugin'
import '.k5{max-width:calc(100% - 140px);}.ssr-plugin'
import '.k6{font-size:4rem;}.ssr-plugin'
import '.ds{font-weight:700;}.ssr-plugin'
import '.k7{line-height:100%;}.ssr-plugin'
import '.go{margin:0px;}.ssr-plugin'
import '.ak{color:var(--brand-secondary);}.ssr-plugin'
import '.al{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c8 x h6 d e k c1 z cq ae"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b9 jz k0 k1 k2 k3 k4 d v k"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c8 ge d e c1 aq k5"
      >
        <div className="k6 ds k7 go ak al"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
